<template>
    <b-modal
        id="modalLabelVideo"
        ref="videoLabelModal"
        title="映像情報をラベリング"
        size="xl"
        cancel-title="キャンセル"
        ok-title="保存"
        centered
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
        @ok.prevent="save"
        @shown="playerInitialize"
        @hidden="close"
        @cancel.prevent="cancel"
    >
        <div
            v-shortkey="['z']"
            @shortkey="shortcut"
        >
            <div class="row">
                <div class="col-8">
                    <div class="size-modal-content d-flex justify-content-center">
                        <div
                            id="playerContainer"
                            ref="playerContainer"
                            class="my-auto"
                        >
                            <video
                                id="videoplayer2"
                                ref="player"
                                style="width: 100%"
                                preload="metadata"
                                playsinline
                                :poster="poster"
                                @loadedmetadata="videoLoaded"
                                @durationchange="durationChange"
                                @timeupdate="timeUpdate"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div
                        class="card info-card"
                        style="min-height: calc(100%);"
                    >
                        <b-button-group class="no-round">
                            <b-button
                                variant="info"
                                size="sm"
                                title="読み込み"
                                @click="fileSelect"
                            >
                                <i
                                    class="icon ion-md-document"
                                /> 読み込み
                                <input
                                    id="upload-file"
                                    ref="file"
                                    type="file"
                                    style="width: 0;"
                                    class="inputfile"
                                    accept=".bacs-s"
                                    @click.stop
                                    @change="loadData"
                                >
                            </b-button>
                            <b-button
                                variant="danger"
                                :disabled="gamedata.length===0"
                                title="削除"
                                @click="removeData"
                            >
                                <i
                                    class="icon ion-md-trash"
                                />
                            </b-button>
                            <b-button
                                variant="secondary"
                                :disabled="gamedata.length===0"
                                title="CSV"
                                @click="exportCSV"
                            >
                                <i
                                    class="icon ion-md-archive"
                                />
                            </b-button>
                            <b-button
                                variant="warning"
                                :disabled="gamedata.length===0"
                                title="一球目設定"
                                @click="setFirstBall"
                            >
                                <i
                                    class="icon ion-md-baseball"
                                />
                            </b-button>
                        </b-button-group>
                        <div class="card-body p-1">
                            <b-list-group ref="chapter_list">
                                <b-list-group-item
                                    v-for="(chapter, i) in gamedata"
                                    :id="'chapter-' + i"
                                    :key="'chapter-' + i"
                                    :class="{ selected: i === currentChapterIdx }"
                                    @click="chapterClick(chapter, i)"
                                >
                                    <div class="row mb-1">
                                        <div class="col-4">
                                            <b-button
                                                v-if="chapter.start_time"
                                                variant="danger"
                                                size="sm"
                                                @click.stop="deleteChapter(i)"
                                            >
                                                <i
                                                    class="icon ion-md-close mr-1"
                                                />連携を取消
                                            </b-button>
                                        </div>
                                        <div class="col-8">
                                            {{ i+1 }} : {{ getTime(chapter.start_time) }} ~ {{ getTime(chapter.end_time) }}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <span class="mr-1 mb-1 badge badge-primary">#{{ players[chapter.pitcher.id].uniform_no }}&nbsp;{{ players[chapter.pitcher.id].name }}</span>
                                            <span class="mr-1 mb-1 badge badge-dark">#{{ players[chapter.catcher.id].uniform_no }}&nbsp;{{ players[chapter.catcher.id].name }}</span>
                                            <span class="mr-1 mb-1 badge badge-warning">#{{ players[chapter.batter.id].uniform_no }}&nbsp;{{ players[chapter.batter.id].name }}</span>
                                            <span class="mr-1 mb-1 badge badge-secondary">{{ chapter.batting_order }}</span>
                                            <span class="mr-1 mb-1 badge badge-success">{{ result['result-'+chapter.batted_ball.result].name }}</span>
                                            <span class="mr-1 mb-1 badge badge-info">{{ pitch_type[chapter.pitch_type].name }}</span>
                                            <span
                                                v-if="chapter.batted_ball.feature"
                                                class="mr-1 mb-1 badge badge-light"
                                            >{{ features[chapter.batted_ball.feature] }}</span>
                                        </div>
                                    </div>
                                </b-list-group-item>
                            </b-list-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import Hls from 'hls.js'
// import dashjs from 'dashjs/dist/legacy/umd/dash.all.min';
import 'vue-slider-component/theme/default.css'
import jsonpack from 'jsonpack'
import saveAs from 'file-saver'
import { compress, decompress } from 'compress-json'
import { results } from '@/variables'

export default {
    name: 'VideoLabelModal',
    data () {
        return {
            hls: null,
            dash: null,
            player: null,
            url: null,
            poster: null,
            loaded: false,
            currentTime: 0,
            duration: 0,
            currentChapterIdx: 0,
            gamedata: [],
            players: {},
            teams: {},
            result: {},
            plan: {},
            pitch_type: {},
            marks: [],
            changed: false,
            features: {
                1: 'ゴロ',
                2: 'フライ',
                3: 'ライナー'
            },
            video: null,
            loadFromServer: false,
            needToPause: 0,
            timer: 0
        }
    },
    created () {
        this.$root.$on('openVideoLabelModal', this.open)
        window.addEventListener('orientationchange', this.resizeOnRotate, false)
        window.addEventListener('resize', this.resizeOnRotate, false)
    },
    destroyed () {
        this.$root.$off('openVideoLabelModal', this.open)
        window.removeEventListener('orientationchange', this.resizeOnRotate, false)
        window.removeEventListener('resize', this.resizeOnRotate, false)
    },
    methods: {
        setFirstBall () {
            if (!this.currentTime) {
                this.$snotify.error('現在の位置が取得できません。')
                return
            }
            const time = this.getTime(this.currentTime)
            this.$swal({
                title: '一球目設定',
                html: '動画の「' + time + '」に一球目を設定しますか。',
                type: 'info',
                showCancelButton: true,
                confirmButtonColor: '#02B875',
                cancelButtonText: 'キャンセル',
                confirmButtonText: 'はい'
            }).then((result) => {
                if (result.value) {
                    const firstDataTime = (new Date(this.gamedata[0].time_count)).getTime() / 1000
                    for (let i = 0; i < this.gamedata.length; i++) {
                        const data = this.gamedata[i]
                        const dataTime = (new Date(data.time_count)).getTime() / 1000
                        const diff = Math.abs(dataTime - firstDataTime)
                        console.log('diff', diff)
                        if (data.time_count) {
                            const currentTime = this.currentTime + diff
                            if (currentTime < this.duration) {
                                let startPad = 4
                                let length = 7
                                const type = 'result-' + data.batted_ball.result
                                if (type === 'result-17') {
                                    startPad = 8
                                    length = 5
                                } else {
                                    const result = results[type]
                                    if (result.batting_flg) {
                                        length = 10
                                    }
                                    console.log(result.name, result.batting_flg)
                                }
                                const start_time = currentTime - startPad
                                const end_time = start_time + length

                                const d = this.$copy(data)
                                Object.assign(d, {
                                    start_time,
                                    end_time
                                })
                                this.$set(this.gamedata, i, Object.freeze(d))
                            }
                        }
                    }
                    this.marks = this.gamedata.filter(x => !!x.start_time).map(x => {
                        return {
                            time: x.start_time,
                            endtime: x.end_time,
                            tip: x.inning + (x.top_bottom ? '表' : '裏') + '：' + this.players[x.pitcher.id].name.split(/[\s,\u3000]+/)[0] + '-' + this.players[x.batter.id].name.split(/[\s,\u3000]+/)[0] + ' (' + x.pitches_to_this_batter + ')'
                        }
                    })
                    this.player.markers = {
                        enabled: true,
                        points: this.marks
                    }
                    this.changed = true
                    clearTimeout(this.timer)
                    this.timer = setTimeout(() => {
                        localStorage.setItem(this.video.video_id, compress({
                            game: this.game,
                            gamedata: this.gamedata,
                            players: this.players,
                            teams: this.teams,
                            result: this.result,
                            plan: this.plan,
                            pitch_type: this.pitch_type,
                            memo: this.memo,
                            stadium: this.stadium,
                            weather: this.weather
                        }))
                    }, 60000)
                }
            })
        },
        removeData () {
            if (!this.gamedata.length) {
                return
            }
            this.$swal({
                title: 'データ削除',
                html: '全てのデータを削除しますか？',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d9534f',
                cancelButtonText: 'キャンセル',
                confirmButtonText: '削除'
            }).then((result) => {
                if (result.value) {
                    this.marks = []
                    this.gamedata = []
                    this.players = {}
                    this.teams = {}
                    this.result = {}
                    this.plan = {}
                    this.game = {}
                    this.stadium = {}
                    this.memo = {}
                    this.weather = {}
                    this.pitch_type = {}
                    this.player.markers = {
                        enabled: true,
                        points: this.marks
                    }
                    clearTimeout(this.timer)
                    localStorage.removeItem(this.video.video_id)
                }
            })
        },
        exportCSV () {
            if (this.marks.length) {
                const csv = this.marks.map(x => {
                    return x.time + ',' + x.endtime + ',' + '"' + x.tip + '"'
                }).join('\n')
                const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
                saveAs(blob, this.teams[this.game.first_team_id].name + '-' + this.teams[this.game.second_team_id].name + '.csv')
            }
        },
        shortcut () {
            this.setChapter(this.currentChapterIdx)
            this.currentChapterIdx++
            this.scrollNextChapter(this.currentChapterIdx)
        },
        open (url, video, data) {
            this.loaded = false
            this.url = url
            this.poster = video.poster
            this.video = video
            this.marks = []
            this.gamedata = []
            this.players = {}
            this.teams = {}
            this.result = {}
            this.plan = {}
            this.game = {}
            this.stadium = {}
            this.memo = {}
            this.weather = {}
            this.pitch_type = {}
            this.loadFromServer = false
            if (data) {
                let unpacked = data
                if (typeof data === 'string') {
                    if (data.startsWith('[') && data.endsWith(']')) {
                        unpacked = decompress(JSON.parse(data))
                    } else {
                        unpacked = jsonpack.unpack(data)
                    }
                }
                console.log(unpacked)
                if (unpacked && unpacked.gamedata) {
                    this.loadFromServer = true
                    this.gamedata = unpacked.gamedata.map(x => Object.freeze(x))
                    this.players = Object.freeze(unpacked.players ?? unpacked.player)
                    this.teams = Object.freeze(unpacked.teams)
                    this.result = Object.freeze(unpacked.result)
                    this.plan = Object.freeze(unpacked.plan)
                    this.game = Object.freeze(unpacked.game)
                    this.stadium = Object.freeze(unpacked.stadium)
                    this.memo = Object.freeze(unpacked.memo)
                    this.weather = Object.freeze(unpacked.weather)
                    this.pitch_type = Object.freeze(unpacked.pitch_type)
                    this.marks = this.gamedata.filter(x => !!x.start_time && !!x.end_time).map(x => {
                        return {
                            time: x.start_time,
                            endtime: x.end_time,
                            tip: x.inning + (x.top_bottom ? '表' : '裏') + '：' + this.players[x.pitcher.id].name.split(/[\s,\u3000]+/)[0] + '-' + this.players[x.batter.id].name.split(/[\s,\u3000]+/)[0] + ' (' + x.pitches_to_this_batter + ')'
                        }
                    })
                }
            }
            this.$nextTick(() => {
                this.$refs.videoLabelModal.show()
            })
        },
        fileSelect () {
            this.$refs.file.value = ''
            this.$refs.file.click()
        },
        loadData (e) {
            const file = e.target.files[0]
            if (file) {
                this.$root.$emit('loading', true)
                let reader = new FileReader()
                reader.addEventListener('load', e => {
                    try {
                        let data = e.target.result
                        if (typeof data === 'string') {
                            if (data.startsWith('[') && data.endsWith(']')) {
                                data = decompress(JSON.parse(data))
                            } else {
                                data = jsonpack.unpack(data)
                            }
                        }
                        const players = {}
                        for (const key in data.players) {
                            delete data.players[key].career
                            players[key] = data.players[key]
                        }
                        console.log(players)
                        this.gamedata = data.gamedata.map(x => Object.freeze(x))
                        this.players = Object.freeze(players)
                        this.teams = Object.freeze(data.teams)
                        this.result = Object.freeze(data.result)
                        this.plan = Object.freeze(data.plan)
                        this.game = Object.freeze(data.game)
                        this.stadium = Object.freeze(data.stadium)
                        this.memo = Object.freeze(data.memo)
                        this.weather = Object.freeze(data.weather)
                        this.pitch_type = Object.freeze(data.pitch_type)

                        this.gamedata.forEach(chapter => {
                            if (!players[chapter.pitcher.id]) {
                                console.log('pitcher', chapter.pitcher.id)
                            }
                            if (!players[chapter.catcher.id]) {
                                console.log('catcher', chapter.catcher.id)
                            }
                            if (!players[chapter.batter.id]) {
                                console.log('batter', chapter.batter.id)
                            }
                        })

                        // const blob = new Blob([JSON.stringify(data)], {type: "application/json;charset=utf-8"});
                        // saveAs(blob, this.teams[this.game.first_team_id].name+'-'+this.teams[this.game.second_team_id].name+".json");
                        data = null
                    } catch (ex) {
                        console.log(ex)
                        if (this.$ab) {
                            this.$ab.notify(ex)
                        }
                    }
                    reader = null
                    this.$root.$emit('loading', false)
                })
                reader.readAsText(file, 'UTF-8')
                this.$nextTick(() => {
                    this.$refs.file.value = ''
                })
            }
        },
        setChapter (i) {
            if (i < this.gamedata.length) {
                if (this.currentTime > 0 && this.currentTime < this.duration) {
                    clearTimeout(this.timer)
                    const start_time = this.currentTime - 2
                    const end_time = start_time + 7
                    const data = this.$copy(this.gamedata[i])
                    Object.assign(data, {
                        start_time,
                        end_time
                    })
                    this.$set(this.gamedata, i, Object.freeze(data))
                    // this.marks = this.gamedata.filter(x => !!x.start_time).reduce((a, c) => {
                    //     a[c.start_time.toString()] = c.page
                    //     return a;
                    // }, {})
                    this.marks = this.gamedata.filter(x => !!x.start_time).map(x => {
                        return {
                            time: x.start_time,
                            endtime: x.end_time,
                            tip: x.inning + (x.top_bottom ? '表' : '裏') + '：' + this.players[x.pitcher.id].name.split(/[\s,\u3000]+/)[0] + '-' + this.players[x.batter.id].name.split(/[\s,\u3000]+/)[0] + ' (' + x.pitches_to_this_batter + ')'
                        }
                    })
                    this.player.markers = {
                        enabled: true,
                        points: this.marks
                    }
                    this.timer = setTimeout(() => {
                        localStorage.setItem(this.video.video_id, compress({
                            game: this.game,
                            gamedata: this.gamedata,
                            players: this.players,
                            teams: this.teams,
                            result: this.result,
                            plan: this.plan,
                            pitch_type: this.pitch_type,
                            memo: this.memo,
                            stadium: this.stadium,
                            weather: this.weather
                        }))
                    }, 60000)
                    this.changed = true
                }
            }
        },
        deleteChapter (idx) {
            const data = this.$copy(this.gamedata[idx])
            delete data.start_time
            delete data.end_time
            this.$set(this.gamedata, idx, Object.freeze(data))
            this.marks = this.gamedata.filter(x => !!x.start_time).map(x => {
                return {
                    time: x.start_time,
                    endtime: x.end_time,
                    tip: x.inning + (x.top_bottom ? '表' : '裏') + '：' + this.players[x.pitcher.id].name.split(/[\s,\u3000]+/)[0] + '-' + this.players[x.batter.id].name.split(/[\s,\u3000]+/)[0] + ' (' + x.pitches_to_this_batter + ')'
                }
            })
            this.player.markers = {
                enabled: true,
                points: this.marks
            }
            this.changed = true
        },
        getTime (sec) {
            if (sec) {
                const secNum = parseInt(sec, 10)
                let hours = Math.floor(secNum / 3600)
                let minutes = Math.floor((secNum - hours * 3600) / 60)
                let seconds = secNum - hours * 3600 - minutes * 60

                if (hours < 10) hours = '0' + hours
                if (minutes < 10) minutes = '0' + minutes
                if (seconds < 10) seconds = '0' + seconds
                return hours + ':' + minutes + ':' + seconds
            }
            return '-'
        },
        durationChange (e) {
            if (e.target.duration !== Infinity) {
                this.duration = Math.ceil(e.target.duration)
            }
        },
        timeUpdate () {
            if (this.player) {
                this.currentTime = this.player.currentTime
                if (this.needToPause && this.player.currentTime >= this.needToPause && this.player.playing) {
                    this.needToPause = 0
                    this.player.pause()
                }
            }
        },
        setTime (sec) {
            if (typeof sec === 'number') {
                this.currentTime = sec
            }
            this.player.currentTime = this.currentTime
        },
        setTime2 () {
            this.player.currentTime = this.currentTime
        },
        chapterClick (c, i) {
            console.log(c, i)
            this.currentChapterIdx = i
            this.needToPause = c.end_time
            this.setTime(c.start_time)
        },
        scrollNextChapter (idx) {
            const li = document.querySelector('#chapter-' + idx)
            li.scrollIntoView({
                block: 'center',
                inline: 'nearest',
                behavior: 'smooth'
            })
        },
        // 以下、modalの処理
        beforeOpen () {
            document.body.classList.add('body-no-scroll')
        },
        beforeClose () {
            if (this.player) {
                this.player.pause()
                this.player.destroy()
                this.player = null
            }
            if (this.dash) {
                this.dash.destroy()
                this.dash = null
            }
            if (this.hls) {
                this.hls.detachMedia()
                this.hls.destroy()
                this.hls = null
            }
            if (this.$refs.player) {
                this.$refs.player.replaceChildren()
            }
            document.body.classList.remove('body-no-scroll')
        },
        save () {
            if (this.gamedata.length || this.loadFromServer) {
                this.$root.$emit('loading', true)
                this.$http.post('video/' + this.video.video_id + '?oper=data', this.gamedata.length
                    ? {
                        data: JSON.stringify(compress({
                            game: this.game,
                            gamedata: this.gamedata,
                            players: this.players,
                            teams: this.teams,
                            result: this.result,
                            plan: this.plan,
                            pitch_type: this.pitch_type,
                            memo: this.memo,
                            stadium: this.stadium,
                            weather: this.weather
                        }))
                    }
                    : {
                        data: ''
                    }).then((r) => {
                    this.$root.$emit('loading', false)
                    if (r) {
                        this.loaded = false
                        this.url = null
                        this.$refs.videoLabelModal.hide()
                        this.$root.$emit('updateTable')
                    }
                    clearTimeout(this.timer)
                }).catch((error) => {
                    this.$root.$emit('loading', false)
                    if (error.response) {
                        if (error.response.data && error.response.data.error) {
                            this.$snotify.error(error.response.data.error)
                        } else {
                            this.$snotify.error('サーバーエラー')
                        }
                    } else if (error.request) {
                        console.log(error.request)
                    } else {
                        console.log(error.config)
                    }
                    if (this.$ab) {
                        this.$ab.notify(error)
                    }
                })
            }
        },
        videoLoaded (e) {
            console.log('loadedmetadata')
            if (e.target) {
                if (!this.loaded) {
                    this.resizePlayer()
                }
            }
        },
        playerInitialize () {
            this.beforeOpen()
            if (this.url) {
                const hlsfmp4 = this.url.hlsfmp4
                // if (/windows|android/i.test(navigator.userAgent)) {
                //     this.dash = dashjs.MediaPlayer().create()
                //     this.dash.initialize(this.$refs.player, this.url.mpd, true)
                //     this.dash.updateSettings({
                //         debug: {
                //             logLevel: dashjs.Debug.LOG_LEVEL_NONE
                //         }
                //     })
                //     console.log('Dash.js initialized')
                // } else
                if (Hls.isSupported()) {
                    this.hls = new Hls(
                        {
                            progressive: true
                        }
                    )
                    this.hls.on(Hls.Events.MEDIA_ATTACHED, () => {
                        this.hls.loadSource(hlsfmp4)
                    })
                    this.hls.attachMedia(this.$refs.player)
                } else if (this.$refs.player.canPlayType('application/vnd.apple.mpegurl')) {
                    const source = document.createElement('source')
                    source.src = this.url.hlsfmp4
                    source.type = 'application/vnd.apple.mpegurl'
                    this.$refs.player.replaceChildren(source)
                    this.$refs.player.load()
                    console.log('Native HLS initialized')
                } else {
                    const source = document.createElement('source')
                    source.src = this.url.direct
                    source.type = 'video/mp4'
                    this.$refs.player.replaceChildren(source)
                    this.$refs.player.load()
                    console.log('Native MP4 initialized')
                }
                // eslint-disable-next-line no-undef
                this.player = new Plyr('#videoplayer2', {
                    fullscreen: { enabled: false },
                    controls: ['play-large', 'rewind', 'play', 'fast-forward', 'progress', 'current-time', 'settings'],
                    hideControls: false,
                    keyboard: { focused: true, global: true },
                    i18n: {
                        restart: '最初から再生',
                        rewind: '巻き戻し {seektime}秒',
                        play: '再生',
                        pause: '一時停止',
                        fastForward: '早送り {seektime}秒',
                        seek: 'シーク',
                        seekLabel: '{currentTime} の {duration}',
                        played: '再生した',
                        buffered: 'バッファーされた',
                        currentTime: '現在時刻',
                        duration: '長さ',
                        volume: 'ボリューム',
                        mute: 'ミュート',
                        unmute: '音',
                        enableCaptions: 'キャプションを有効化',
                        disableCaptions: 'キャプションを無効化',
                        download: 'ダウンロード',
                        enterFullscreen: '全画面モード',
                        exitFullscreen: '全画面モードを閉じる',
                        frameTitle: '{title}のプレイヤー',
                        captions: 'キャプション',
                        settings: '設定',
                        menuBack: '戻る',
                        speed: '再生速度',
                        normal: '普通',
                        quality: '画質',
                        loop: 'ループ',
                        start: '開始',
                        end: '終了',
                        all: 'すべて',
                        reset: 'リセット',
                        disabled: '無効化された',
                        enabled: '有効化された',
                        advertisement: '広告',
                        qualityBadge: {
                            2160: '4K',
                            1440: 'HD',
                            1080: 'HD',
                            720: 'HD',
                            576: 'SD',
                            480: 'SD'
                        }
                    },
                    markers: {
                        enabled: true,
                        points: this.marks
                    }
                })
                this.changed = false
            }
        },
        resizePlayer () {
            if (this.$refs.player) {
                const h = this.$refs.player.videoHeight || this.$refs.player.clientHeight
                const w = this.$refs.player.videoWidth || this.$refs.player.clientWidth
                if (h && w) {
                    let nh = document.documentElement.clientHeight
                    let nw = Math.floor(nh * (w / h))
                    if (nw > document.documentElement.clientWidth) {
                        nw = document.documentElement.clientWidth
                        nh = Math.floor(nw * (h / w))
                    }
                    this.$refs.playerContainer.style.height = 'auto'
                    this.$refs.playerContainer.style.width = nw + 'px'
                    this.loaded = true
                    this.$refs.chapter_list.style.height = (this.$refs.playerContainer.clientHeight - 40) + 'px'
                }
            }
        },
        resizeOnRotate () {
            if (this.loaded) {
                this.resizePlayer()
            }
        },
        close () {
            this.beforeClose()
            this.loaded = false
            this.url = null
            this.marks = []
            this.gamedata = []
            this.players = {}
            this.teams = {}
            this.result = {}
            this.plan = {}
            this.game = {}
            this.stadium = {}
            this.memo = {}
            this.weather = {}
            this.pitch_type = {}
            clearTimeout(this.timer)
            localStorage.removeItem(this.video.video_id)
        },
        cancel () {
            if (this.changed) {
                this.$swal({
                    text: '保存されてない変更があります。本当に閉じますか？',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#ed9d2b',
                    cancelButtonText: 'キャンセル',
                    confirmButtonText: '閉じます'
                }).then((result) => {
                    if (result.value) {
                        this.$refs.videoLabelModal.hide()
                    }
                })
            } else {
                this.$nextTick(() => {
                    this.$refs.videoLabelModal.hide()
                })
            }
        }
    }
}
</script>

<style scoped>
/deep/ #modalLabelVideo .modal-dialog {
    width: 100%;
    max-width: 100%;
}

.list-group {
    height: 400px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

.no-round .btn {
    border-radius: 0;
}

.selected {
    background-color: rgba(46, 114, 234, 0.63);
}
</style>
